module.exports = __webpack_public_path__ + "static/media/router.e82fb322.svg";